"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Boards = void 0;
const base_1 = require("../../base");
// :TODO: Add in future support for predefined images and direct image uploads
//        https://www.notion.so/airinc/UI-2-0-2085596f7bbd80cd9421ed837aa36564?source=copy_link#2155596f7bbd80f58f4dc7362265741a
/*
& (
  | { clipId?: string }
  | { predefined?: string } // Predefined names of images in a special S3 bucket
  | { imageBlob?: string } // Upload image (to special S3 bucket)
);
*/
exports.Boards = {
    deleteCoverImage: (0, base_1.declare)({
        method: 'delete',
        path: '/workspaces/:workspaceId/boards/:boardId/covers',
    }).as(),
    setCoverImage: (0, base_1.declare)({
        method: 'post',
        path: '/workspaces/:workspaceId/boards/:boardId/covers',
    }).as(),
};
//# sourceMappingURL=index.js.map